export default function getTotalHeightWithMargin(element) {
  const computedStyle = window.getComputedStyle(element);
  const marginTop = parseFloat(computedStyle.marginTop);
  const marginBottom = parseFloat(computedStyle.marginBottom);

  return element.scrollHeight + marginTop + marginBottom;
}
